import { DateValue } from "@mantine/dates"
import { Property } from "./property.model"
import { Tenant } from "./tenant.model"
import { Unit } from "./unit.model"
import { Owner } from "./owner.model"

export type TenantRequest = {
  id: string
  name: string
  propertyId: string
  property: Property
  tenantId: string
  maintenanceId?: string
  maintenance?: Owner
  tenant: Tenant
  unitId: string
  unit: Unit
  status?: TenantRequestStatus
  description: string
  fileNames?: string[]
  files?: any
  minioFiles?: string[]
  type: string
  priority: string
  archiveReason: string
  createdBy: string
  updatedBy: string
  enabled: boolean
  createdAt: DateValue
  updatedAt: DateValue
  deletedAt: DateValue
  deletedBy: string
}


export enum TenantRequestStatus {
  Pending = "Pending",
  InProgress = "InProgress",
  Completed = "Completed",
}